import EventHandler from '@pixelunion/events';
import { transition } from '@pixelunion/animations';

export default class SearchFilterDisclosures {
  constructor(sectionEl) {
    this.el = sectionEl;
    this.events = new EventHandler();
    this.summaryElSelector = '[data-filter-group-summary]';
    this.dropdownSelector = '[data-filter-group]';
    this.filterContainerSelector = '[data-filter-container]';
    this.closedState = 'closed';
    this.openState = 'open';
    this.disclosureAnimations = {};
    this.init();
  }

  init() {
    this._initAnimations();
    this._bindEvents();
  }

  _bindEvents() {
    const summaryEls = this.el.querySelectorAll(this.summaryElSelector);

    this.events.register(window, 'resize', () => {
      this.el.querySelectorAll(this.filterContainerSelector)
        .forEach(el => {
          this._setStyleVariables(el);
        });
    });

    summaryEls.forEach(summary => {
      this.events.register(summary, 'click', event => this._animateDisclosure(event));
    });

    /* When clicking outside dropdown element, close dropdown */
    this.events.register(document.body, 'click', e => {
      if (!e.target.closest('[data-filter-group]')) {
        this.closeAllDropdowns();
      }
    });
  }

  _initAnimations() {
    const summaryEls = this.el.querySelectorAll(this.summaryElSelector);

    summaryEls.forEach(summary => {
      const filterList = summary.nextElementSibling;
      const currentDetailsEl = summary.closest('[data-filter-group]');
      const index = summary.dataset.filterGroupIndex;
      this.disclosureAnimations[index] = transition({ el: filterList, state: this.closedState });
      currentDetailsEl.style.setProperty('--closed-height', `${summary.offsetHeight}px`);
    });
  }

  _animateDisclosure(event) {
    event.preventDefault();
    const summary = event.currentTarget;
    const filterList = summary.nextElementSibling;
    const currentDetailsEl = summary.closest('[data-filter-group]');

    /* Handle dropdowns on click event outside disclosure */
    if (filterList == null) {
      this.closeAllDropdowns();
      return;
    }

    // if (filterList.dataset.animation) return;

    if (filterList.dataset.animationState === this.openState) {
      this.closeDisclosure(currentDetailsEl);
    } else {
      /* Close any open dropdowns before opening new dropdown */
      this.closeAllDropdowns();
      this.openDisclosure(currentDetailsEl);
    }
  }

  openDisclosure(detailsEl) {
    const index = detailsEl.querySelector(this.summaryElSelector).dataset.filterGroupIndex;
    detailsEl.setAttribute('open', '');

    this.disclosureAnimations[index]
      .animateTo(this.openState, {
        onStart: ({ el }) => {
          this._setStyleVariables(el);
        },
      });

    detailsEl.classList.add('dropdown-expanded');
  }

  _setStyleVariables(el) {
    const container = document.querySelector('.productgrid--wrapper');
    const containerStyle = window.getComputedStyle
      ? getComputedStyle(container, null)
      : container.currentStyle;
    const paddingLeft = parseInt(containerStyle.paddingLeft, 10) || 0;
    const paddingRight = parseInt(containerStyle.paddingRight, 10) || 0;

    const elementBounds = el.getBoundingClientRect();
    const rightBounds = elementBounds.right;
    const leftBounds = elementBounds.left;

    if (rightBounds >= window.innerWidth) {
      el.classList.add('filters--overflow-right');
    }

    if (leftBounds <= 0) {
      el.classList.add('filters--overflow-left');
    }

    const mobileWidth = container.getBoundingClientRect().width - paddingLeft - paddingRight;

    el.style.setProperty('--mobile-width', `${mobileWidth}px`);
    el.style.setProperty('--open-height', `${el.offsetHeight}px`);
  }

  closeDisclosure(detailsEl) {
    const index = detailsEl.querySelector(this.summaryElSelector).dataset.filterGroupIndex;

    this.disclosureAnimations[index]
      .animateTo(this.closedState)
      .then(() => {
        detailsEl.removeAttribute('open');
      });

    detailsEl.classList.remove('dropdown-expanded');
  }

  closeAllDropdowns() {
    const dropdowns = this.el.querySelectorAll(this.dropdownSelector);
    dropdowns.forEach(dropdown => {
      if (dropdown.classList.contains('dropdown-expanded')) {
        this.closeDisclosure(dropdown);
      }
    });
  }

  unload() {
    this.events.unregisterAll();
    this.disclosureAnimations = {};
  }
}
